<template>
  <div class="lby-chart" ref="chartbody">
    <div class="lby-title">战斗力排行榜</div>
    <div class="boundary-line"></div>
    <table class="lby-table"  v-if="list.length>0">
        <tr>
          <td>排序</td>
          <td>战斗力</td>
          <td style="padding-left: 10px;">玩家昵称</td>
          <td style="padding-left: 100px;box-sizing: border-box;">宝宝</td>
          <td style="padding-left: 50px;">区服</td>
        </tr>
        <tr v-for="(item,index) in list" :key="item.id" @click="toRankingList" style="cursor: pointer;">
          <td>{{index+1}}</td>
          <td  style="color:#fbff00;font-weight: bolder;letter-spacing: 1px;transform: scale(1.3);">{{item.number}}</td>
          <td style="padding-left: 10px;">{{item.name}}</td>
          <td style="padding-left: 30px;">{{item.babys}}</td>
          <td>{{regionName(item.region)+serverName(item.server)}}</td>
        </tr>
    </table>
    <table v-else>
      <tr><th>暂无排行榜数据</th></tr>
    </table>
  </div>
</template>

<script>
import { getCombatRankingList } from '@/api/rankinglist/index'
export default {
  name: 'MyChart',
  data () {
    return {
      activeIndex: -1,
      list: []
    }
  },
  methods: {
    toRankingList () {
      this.$router.push({
        path: '/rankinglistindex'
      })
    },
    async getRangingList () {
      const resCBR = await getCombatRankingList({ pageNo: 1, pageSize: 10 })
      this.list = resCBR.data.list
    }
  },
  created () {
    this.getRangingList()
  },
  computed: {
    serverName () {
      return (serverId) => {
        return this.$store.getters['basicdata/serverName'](serverId)
      }
    },
    regionName () {
      return (regionId) => {
        return this.$store.getters['basicdata/regionName'](regionId)
      }
    }
  }
}
</script>

<style scoped lang="less">
.lby-chart{
    width: 780px;
    height: 350px;
    margin-left: 16px;
    border-radius: 10px;
    border: 1px solid rgb(134, 134, 134);
    background: linear-gradient(to right, #312951,#644097,#4788c2, #503d99);
    box-shadow: 0 0 2px #d3d3d3;
    box-sizing: border-box;
    color:white;
    .boundary-line{
      width: 90%;
      height: 2px;
      background: linear-gradient(to right,#f796fc, #b4a2ff,#71bfff, #f796fc);
      margin:0px auto ;
    }
    .lby-title{
        font-size: 17px;
        margin:10px auto ;
        height: 20px;
        margin-bottom: 5px;
    }

    .lby-table{
        margin: 10px auto;
        margin-top:5px;
        border-spacing: 10px;
        width: 100%;
        box-sizing: border-box;
        padding-left: 10px;
        tr{
          height: 27px;
          line-height: 27px;
        }
        tr:hover{
          background: linear-gradient(to right, #4e4280,#794eb4,#5da8eb, #765ed8);
          box-shadow: 0 0 5px rgb(0, 0, 0);
        }
        tr td:nth-child(1){
          width: 50px;
        }
        tr td:nth-child(2){
          width: 60px;
        }
        tr td:nth-child(3){
          width: 100px;
        }
        tr td:nth-child(4){
          width: 220px;
          white-space: nowrap;         /* 禁止换行 */
          overflow: hidden;            /* 隐藏溢出内容 */
          text-overflow: ellipsis;
          text-align: left;
        }
        tr td:nth-child(5){
          width: 170px;
          white-space: nowrap;         /* 禁止换行 */
          overflow: hidden;            /* 隐藏溢出内容 */
          text-overflow: ellipsis;
          text-align: left;
        }
    }
}

</style>
